<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="考勤设备"
      edit-title
      id-key="DeviceId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备编号" prop="DeviceNo">
              <el-input v-model="data.DeviceNo" v-int placeholder="请输入设备编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备名称" prop="DeviceName">
              <el-input v-model="data.DeviceName" placeholder="请输入设备名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备IP" prop="Ip">
              <el-input v-model="data.Ip" placeholder="请输入设备IP"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="端口号" prop="Port">
              <el-input v-model="data.Port" placeholder="请输入端口号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="设备位置" prop="Place">
              <el-input v-model="data.Place" placeholder="请输入设备位置"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备地点" prop="Building">
              <el-input v-model="data.Building" placeholder="请输入设备地点" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备分组" prop="GroupName">
              <el-input v-model="data.GroupName" placeholder="请输入设备分组" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB?24:12">
            <el-form-item label="楼层" prop="Floor">
              <el-input v-model="data.Floor" oninput="value=value.replace(/[^\d]/g,'')" type="number" placeholder="请输入楼层" clearable></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="晚休考勤" prop="NightAttendance" class="is-required">
              <el-radio-group v-model="data.NightAttendance">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="row-tb-head">
              <span>晚休宿舍列表</span>
              <div style="float: right;">
                <el-button type="primary" icon="el-icon-plus" @click="addDorm">添加</el-button>
                <el-button type="danger" @click="delDorms">删除</el-button>
              </div>
            </div>
            <el-table ref="tb_dorm" class="tb-c-head" :data="tableData" border>
              <el-table-column type="selection" width="40px" align="center" />
              <el-table-column label="宿舍号" prop="DormitoryNo" align="center" />
              <el-table-column label="操作" align="center" fixed="right" width="80px">
                <template slot-scope="{row,$index}">
                  <el-button type="text" @click="del(row,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12" style="padding-top:12px;margin-bottom: -20px;">
            <el-form-item label="留宿自习考勤" prop="StayAttendance" class="longLabel is-required">
              <el-radio-group v-model="data.StayAttendance">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="row-tb-head">
              <span>留宿班级列表</span>
              <div style="float: right;">
                <el-button type="primary" icon="el-icon-plus" @click="addClass">添加</el-button>
              </div>
            </div>
            <el-table class="tb-c-head" :data="tableData2" border>
              <el-table-column label="年级" prop="GradeSn" align="center" width="140px">
                <template slot-scope="{row}">
                  <el-select v-model="row.GradeSn">
                    <el-option :value="1" label="高一"></el-option>
                    <el-option :value="2" label="高二"></el-option>
                    <el-option :value="3" label="高三"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="班级序号" prop="GradeSn" align="center">
                <template slot-scope="{row,$index}">
                  <el-select v-model="row.cs" @change="tbUpdate($index)" placeholder="放空即为所有班级" clearable multiple>
                    <el-option v-for="item in 50" :key="item" :value="item"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" fixed="right" width="60px">
                <template slot-scope="{row,$index}">
                  <el-button type="text" @click="delDevice(row,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <dorm-dialog ref="dormDialog" in-dialog selectable multiple @select-multiple="setDorms" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dormDialog from "@/components/lo/dorm/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dormDialog
  },
  data() {
    return {
      data: {
        DeviceId: 0,
        DeviceNo: "",
        DeviceName: "",
        Port: "",
        UdpIp: "",
        UdpPort: 0,
        Ip: "",
        Place: "",
        Status: 1,
        DeviceType: 1,
        Building: "",
        GroupName:"",
        Floor: "",
        NightAttendance: 0,
        StayAttendance: 0,
        Dormitorys: [],
        Grades: [],
      },
      tableData: [],
      tableData2: [],
      delList: [],
      delList2: [],
      isMB: this.$store.state.isMB,
      api: require("@/api/cp/device").default,
      rules: {
        DeviceNo: [{ required: true, message: "设备编号不能为空" }],
        DeviceName: [{ required: true, message: "设备名称不能为空" }],
        Ip: [{ required: true, message: "IP不能为空" }],
        Port: [{ required: true, message: "端口号不能为空" }],
        Place: [{ required: true, message: "设备位置不能为空" }],
        // Building: [{ required: true, message: "设备建筑不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened() {
    },
    onEditOpened(data) {
      data.Dormitorys.forEach(e => {
        e.T = 1;
      })
      data.Grades.forEach(e => {
        e.T = 1;
        e.cs = [];
      })
      this.tableData = data.Dormitorys;
      if(data.Grades.length) {
        data.Grades.forEach(e => {
          if(e.ClassSns) {
            var arr = e.ClassSns.split(",");
            e.cs = arr.map(x => Number(x));
          } else {
            e.cs = [];
          }
        })
        this.tableData2 = data.Grades;
      }
    },
    addDorm() {
      this.$refs.dormDialog.open().then((that) => {
        that.getData({ DeviceId: this.data.DeviceId });
      });
    },
    setDorms(dorms) {
      if(dorms.length == 0) return;
      var same = [];
      dorms.forEach(e => {
        var obj = this.tableData.find(x => {
          return x.DormitoryId == e.DormitoryId;
        })
        if(obj) {
          same.push(e.DormitoryNumber);
        } else {
          this.tableData.push({
            DeviceDormitoryId: 0,
            DormitoryId: e.DormitoryId,
            DormitoryNo: e.DormitoryAddr + e.DormitoryNumber,
            T: 0,
          });
        }
      })
      if(same.length) {
        this.$message.error("已存在相同的宿舍号：" + same.join("，"));
      }
    },
    addClass() {
      if(this.tableData2.length==3) {
        this.$message.warning("最多添加3条记录");
        return;
      }
      this.tableData2.push({
        T: 0,
        DeviceGradeId: 0,
        DeviceId: this.data.DeviceId,
        GradeSn: 1,
        ClassSns: "",
        cs: [],
      })
    },
    tbUpdate(index) {
      this.tableData2.splice(index,1,this.tableData2[index]);
    },
    delDorms() {
      var rows = this.$refs.tb_dorm.selection;
      if(rows.length==0) {
        this.$message.error("请选择要删除的数据");
        return;
      }
      var ids = rows.map(x => x.DormitoryId);
      ids.forEach(e => {
        var obj = this.tableData.find(x => x.DormitoryId == e);
        var index = this.tableData.findIndex(x => x.DormitoryId == e);
        if(index > -1) {
          this.del(obj,index);
        }
      })
    },
    del(row,index) {
      if(!(row.T===0)) {
        row.T = 2;
        this.delList.push(row);
      }
      this.tableData.splice(index,1);
    },
    delDevice(row,index) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if(!(row.T===0)) {
            row.T = 2;
            this.delList2.push(row);
          }
          this.tableData2.splice(index, 1);
        })
        .catch(() => { });
    },
    onBeforeSave() {
      var td = this.tableData;
      var td2 = this.tableData2;
      var dl = this.delList;
      var dl2 = this.delList2;
      this.data.Dormitorys = td.concat(dl);
      for (let i = 0; i < td2.length; i++) {
        const e = td2[i];
        for (let j = 0; j < td2.length; j++) {
          const n = td2[j];
          if(n.GradeSn == e.GradeSn && j != i) {
            this.$message.error("留宿列表存在相同的年级");
            return false;
          }
        }
      }
      td2.forEach(e => {
        if(e.cs.length) {
          e.ClassSns = e.cs.join(",");
        } else {
          e.ClassSns = "";
        }
      })
      this.data.Grades = td2.concat(dl2);
    },
    onClosed() {
      this.tableData = [];
      this.tableData2 = [];
      this.delList = [];
      this.delList2 = [];
    }
  },
};
</script>